module.exports = __webpack_public_path__ + "fonts/MuseoSansCyrl-300.b629c23.otf";